/**
 * This tab's id for one page load (NG-3587). The shared API client sends it on
 * every request as {@link TAB_ID_HEADER}, and a cache hint a write sends names
 * it back as `origin_tab_id`, so the tab that wrote can tell its own echo from
 * another tab's write (`stores/cache-hints/listener.ts`).
 *
 * Kept in memory, never in sessionStorage: a duplicated tab copies
 * sessionStorage, and the copy would then take the original's writes for its
 * own. Random, so it names a page load and nothing else. The backend accepts
 * `[A-Za-z0-9-]{1,64}` and drops anything else, which every value here fits.
 */
export const TAB_ID: string = newTabId();

/** The request header that carries {@link TAB_ID}; the API allows it in `CORS_ALLOW_HEADERS`. */
export const TAB_ID_HEADER = "X-Tab-Id";

function newTabId(): string {
  // `randomUUID` needs a secure context (https or localhost); `getRandomValues` does not.
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
